import { Params } from 'app/types';

import { QueryKey } from '@tanstack/react-query';

export const getQueryKeyByModel = (model: Params): QueryKey => {
  if (model.type === 'draft_certificate_pdf') {
    return ['applications', model.applicationId, 'certificate'];
  }

  if (model.type === 'csv_export_changes_log') {
    return ['csv_export_changes_log', model.applicationId];
  }

  if (model.type === 'csv_export_applications') {
    return ['csv_export_applications'];
  }

  if (model.type === 'csv_export_tickets') {
    return ['csv_export_tickets'];
  }

  if (model.type === 'csv_export_inspector_profiles') {
    return ['csv_export_inspector_profiles'];
  }

  if (model.type === 'csv_export_agencies') {
    return ['csv_export_agencies'];
  }

  return [];
};
